"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextButton = void 0;
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const TextButton = ({ text, width, height, disabled, className, gameplayStyle: componentStyle, highlighted, onInteract, blurred, }) => {
    return (react_1.default.createElement(material_1.ButtonBase, { disableRipple: true, disabled: disabled, onClick: () => {
            onInteract && onInteract(text);
        }, className: `${className}-${componentStyle} ${highlighted ? 'highlighted' : ''} ${blurred ? 'blurred' : ''}`, sx: {
            width: width ? `${width}` : '100%',
            height: height ? `${height}` : '100%',
        } },
        react_1.default.createElement(material_1.Typography, null, text)));
};
exports.TextButton = TextButton;
